<mat-dialog-content
  class="mat-mdc-dialog-surface mdc-dialog__surface bg-[#FFFFFF] !w-[65vw]  !rounded-none"
  style="
    overflow: visible;
    padding-top: 0px;
    padding-left: 0px;
    padding-right: 0px;
  "
>
  <!-- Close Icon -->
  <div class="w-full flex justify-between items-center h-[57px] bg-[#F5F5F5]">
    <h2
      class="pl-[36px] text-[#21252A] text-[20px] font-bold items-center !mb-0"
    >
      Attach Documents
    </h2>
    <button
      mat-icon-button
      mat-dialog-close
      aria-label="Close"
      class="pr-[13px]"
    >
  <mat-icon class="!text-[24px] !font-bold "> close</mat-icon>
    </button>
  </div>

  <div class="bg-[#FFFFFF] !py-[24px] !px-[10px] !pb-[0px] ">
    <p class="text-gray-600 !text-[16px] !ml-[25px]">
      Add your documents here, and you can upload up to 5 files Max
    </p>
    <div>
      <div
        class="flex flex-col items-center justify-center p-6 border-2 ml-[25px] mr-[25px] border-dashed h-[25vh] border-gray-300 bg-[#F7F6FB] hover:bg-orange-500 hover:bg-opacity-10 cursor-pointer transition-all duration-300"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
        [class.bg-blue-50]="isDragging"
      >
        <button
          class="bg-[#D9D9D9] text-[#21252A] px-4 py-2 rounded-[3px] focus:outline-none"
          (click)="fileInput.click()"
        >
          Attach File
        </button>
        <p class="text-[15px] font-semibold text-[#21252A] !mb-0">
          Drag & Drop
        </p>
        <input
          type="file"
          #fileInput
          (change)="onFileSelected($event)"
          multiple
          hidden
        />
      </div>
    </div>
    <p class="text-gray-600 !text-[16px] !ml-[25px]">
      Only support .jpg, .png .svg, .pdf and zip files
    </p>
  
    <div class="mb-[10px]" *ngIf="files.length > 0">
      <!-- <h3 class="!font-semibold text-lg  !ml-[25px] font-Roboto !text-[18px]">
        Documents
      </h3> -->

      <ul class="mr-[25px] table-scroll overflow-y-auto">
        <li
          *ngFor="let file of files; let i = index"
          class="bg-gray-100 text-gray-700 border flex items-center px-4 py-2 mb-2 rounded-[3px] relative"
        >
          <div class="flex justify-between items-center w-[100%]">
            <div class="flex items-center">
              <!-- File Icon -->
              <div
              class="relative !mt-[3px] w-[1.5rem] h-[1.5rem] overflow-hidden"
            >
              <img
                [src]="getFileIcon(file)"
                alt="File Preview"
                class="object-cover w-auto h-[100%] cursor-pointer"
              />
            </div>
              <div class="file-item">
                <span
                  *ngIf="!isEditing"
                  class="!min-w-[237px] !h-auto border border-gray-400 h-auto ml-[20px] p-[5px]"
                  (click)="startEditing(i)"
                  >{{ file.name }}</span
                >

                <input
                  *ngIf="isEditing"
                  [(ngModel)]="newFileName"
                  (blur)="saveFileName()"
                  (keydown.enter)="saveFileName()"
                />

                <!-- <button class="ml-[20px]" *ngIf="!isEditing">Edit</button> -->
                <!-- <button *ngIf="isEditing" (click)="cancelEditing()">Cancel</button> -->
              </div>

              <!-- Delete Button -->
              <button
                class="text-[#2368A2] ml-[10px] absolute right-[3px] top-[11px]"
                (click)="removeFile(i)"
              >
              <img src="assets/icons/close-icon.svg" alt="close-icon" />
              </button>
            </div>
            <div>
              <!-- <mat-spinner
                *ngIf="showSpinner"
                class="spinner"
                style="align-items: end"
              ></mat-spinner> -->
            </div>
          </div>
        </li>
      </ul>
    </div>
    <!-- Buttons -->
    <div class="flex justify-end sticky !p-0 !bottom-0 !z-20">
      <button
        class="!bg-[#F1F3F5] !rounded-[3px] !text-[#E76B3F] w-[84px] h-[42px] mr-[15px] my-[10px]"
        mat-button
        mat-dialog-close
        style="border: 1px solid #e76b3f"
      >
        Cancel
      </button>
      <button
        class="!bg-[#E76B3F] !rounded-[3px] !text-white w-[84px] h-[42px] mr-[25px] my-[10px]"
        mat-button
        [mat-dialog-close]="true"
        (click)="uploadFile()"
      >
        Process
      </button>
    </div>
  
  </div>
</mat-dialog-content>
